export default __webpack_public_path__ + "static/media/carosello1.36b2d80f.png";